export interface ICompletionStage {
  stage: number;
  progress: number;
}

export class CompletionStage {
  public stage: number;
  public progress: number;

  constructor(data: ICompletionStage) {
    this.stage = data.stage;
    this.progress = data.progress;
  }
}
